<mat-icon [class]="isOverride() ? 'positive' : ''">
  @switch (type()) {
    @case ('change') {
      radio_button_checked
    }
    @case ('issue') {
      request_quote
    }
    @case ('income') {
      paid
    }
    @case ('ucThreshold') {
      credit_card
    }
    @case ('blancoLoansThreshold') {
      credit_card
    }
    @case ('blancoLoansMatchingUC') {
      credit_card
    }
    @case ('retiredCheck') {
      elderly_woman
    }
    @case ('propertyLoansMatchingUC') {
      home
    }
    @case ('occupation') {
      work
    }
    @case ('oldProperty') {
      home
    }
    @case ('note') {
      note_alt
    }
  }
</mat-icon>
